// extracted by mini-css-extract-plugin
export default {"qaPage":"QA_qaPage__lY5Yf","qaSection":"QA_qaSection__KB8pz","dmqaPage":"QA_dmqaPage__1Puo5","dmqaSection":"QA_dmqaSection__FNt8i"};